export const GOOGLE_KEYS = [
  "AIzaSyDYKIlLjheA0XRFRj3A1LlyV-SBgBUIEDw",
  //   "AIzaSyC6w8P9y6K9U4ujiwggeG7TIAOi-Cz-qGw",
  //   "AIzaSyC87lhAl1fpFNKB9SB1suB8OebDAli9Iw0",
  //   "AIzaSyAV9qAXl2Y_Kh0dl_4PXLTZuPoQMKdcw3M",
];
export const googleApiUrl = "https://maps.googleapis.com/maps/api/js";
